var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { I18nManager } from 'react-native';
import PropTypes from 'prop-types';
export default function flipOnRTL(WrappedComponent) {
    var _a;
    return _a = class RTLImage extends Component {
            render() {
                const _a = this.props, { flipOnRTL } = _a, rest = __rest(_a, ["flipOnRTL"]);
                const RTLStyle = flipOnRTL ? { transform: [{ scaleX: I18nManager.isRTL ? -1 : 1 }] } : {};
                return <WrappedComponent {...rest} style={[RTLStyle, rest.style]}/>;
            }
        },
        _a.propTypes = {
            /**
             * When true, image is flipped on RTL
             */
            flipOnRTL: PropTypes.bool,
        },
        _a.defaultProps = {
            flipOnRTL: false,
        },
        _a;
}
